import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core'
import { code128, drawingSVG } from '@bwip-js/browser'

@Component({
  selector: '[lemon-barcode]',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BarcodeComponent implements OnChanges {
  @Input() barcodeValue = ''

  private viivakoodinKorkeusMillimetreissa = 10

  constructor(
    private _renderer: Renderer2,
    private _elementRef: ElementRef<HTMLDivElement>,
  ) {}

  ngOnChanges() {
    this.createBarcode()
  }

  createBarcode() {
    const svg = code128(
      {
        bcid: 'code128', // Barcode type
        text: this.barcodeValue ?? '', // Text to encode
        scale: 1, // 3x scaling factor
        height: this.viivakoodinKorkeusMillimetreissa, // Bar height, in millimeters
        includetext: false, // Show human-readable text
        textxalign: 'center', // Always good to set this
        monochrome: true,
        borderleft: 0,
        borderbottom: 0,
        borderright: 0,
        bordertop: 0,
      },
      drawingSVG(),
    )

    this._renderer.setProperty(this._elementRef.nativeElement, 'innerHTML', svg)
  }
}
